/**
 * Workspace Autopilot page — Project Harmony
 *
 * Standalone destination for the full Autopilot cockpit (department
 * health · trust level · human override · department autonomy · living
 * timeline). Reuses the frozen ``AutopilotSection`` component — no
 * duplicate surface, no divergence.
 */
import { AutopilotSection } from "@/features/autopilot";

export default function WorkspaceAutopilotPage(): JSX.Element {
  return (
    <div
      className="mx-auto max-w-[1120px] px-4 py-8 md:px-8 md:py-12"
      data-testid="workspace-autopilot-page"
    >
      <AutopilotSection />
    </div>
  );
}
